import { TableCell, TableRow, Typography } from "@mui/material"
import { navigate } from "lib/routes/navigate"
import { CriticalityIcon } from "routes/schedule/plugins/legislation-resolutions/criticality-icon"
import { ChangeTypeSummaryIcons } from "routes/schedule/plugins/legislation-resolutions/change-type-summary-icons"
import { ResolutionStatusChip } from "routes/schedule/plugins/legislation-resolutions/resolution-status-chip"
import { ProjectBridgeMappingStatusChip } from "./project-bridge-mapping-status-chip"
import { getProjectBridgeDetailPath } from "./project-bridge-route-paths"
import { ProjectBridgeRowSelector } from "./project-bridge-row-selector"

export function ProjectBridgeListRow({ item }) {
    const changes = item?.proposedChanges ?? []
    const decisionsLabel = item?.changeCount ? `${item?.decidedCount || 0} / ${item?.changeCount || 0}` : "—"

    return (
        <TableRow hover sx={{ cursor: "pointer" }} onClick={openDetail}>
            <ProjectBridgeRowSelector item={item} />
            <TableCell>
                <Typography variant="body2" fontWeight="bold">
                    {item?.code}
                </Typography>
            </TableCell>
            <TableCell>{item?.title}</TableCell>
            <TableCell>
                <ProjectBridgeMappingStatusChip status={item?.mappingStatus} />
            </TableCell>
            <TableCell>
                <ResolutionStatusChip status={item?.status} />
            </TableCell>
            <TableCell>{`${Number(item?.overallMatchPercent || 0)}%`}</TableCell>
            <TableCell>{Number(item?.readySectionCount || 0)}</TableCell>
            <TableCell>{Number(item?.unresolvedSectionCount || 0)}</TableCell>
            <TableCell>
                <ChangeTypeSummaryIcons changes={changes} />
            </TableCell>
            <TableCell>
                <CriticalityIcon criticality={item?.criticality} />
            </TableCell>
            <TableCell>{Number(item?.changeCount || 0) || "—"}</TableCell>
            <TableCell>{decisionsLabel}</TableCell>
        </TableRow>
    )

    function openDetail() {
        navigate(getProjectBridgeDetailPath(item?.id))
    }
}
